(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('UnitListFranchiserController', UnitListFranchiserController)

    /** @ngInject */
    function UnitListFranchiserController($q, $httpParamSerializer, UnitService, EconomicGroupService, ClusterService, HelperService, AuthenticationService, NotifyService, sweetAlert, SYSTEM_MODULES, ROUTES, ReportDownloadService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;
        let hasModifiedSearchStatus = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedEconomicGroup || vm.selectedCluster || vm.selectedStatus || hasModifiedSearchStatus || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedEconomicGroup || vm.selectedCluster || vm.selectedStatus || hasModifiedSearchStatus || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.changeUnitStatus = status => {
            if (vm.selectedStatus && vm.selectedStatus.Id == 6) return;

            vm.searchStatus = status;
            hasModifiedSearchStatus = true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedEconomicGroup = null;
            vm.selectedCluster = null;
            vm.selectedStatus;
            vm.selectedSearchField = null;
            vm.searchText = null;
            vm.searchStatus = 2;
            hasModifiedSearchStatus = false;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getUnits(start, number, tableState);
        }

        vm.configureReportDownload = () => {
            const parameters = prepareReportParameters();

            return ReportDownloadService.download('units-report', parameters);
        }

        vm.refreshAllUnits = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você está prestes a atualizar os dados de todas as lojas. Essa ação é irreversível!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.application-loader');

                    UnitService
                        .refreshUnitFromIdeologica()
                        .then(() => {
                            NotifyService.success('Lojas atualizadas com sucesso!');
                            HelperService.stopLoading('.application-loader');
                        }, error => {
                            HelperService.stopLoading('.application-loader');
                            HelperService.errorCallback(error);
                        })
                }
            })
        }

        init();

        function getUnits(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            UnitService
                .getByParameters(parameters)
                .then(success => {
                    vm.units = success.Units;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.units = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function getEconomicGroups() {
            EconomicGroupService
                .getAll()
                .then(success => {
                    vm.economicGroups = success;
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function getClusters() {
            return ClusterService
                .getAll()
                .then(success => {
                    vm.clusters = success;
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function getStatus() {
            return UnitService
                .getStatus()
                .then(success => {
                    vm.status = success;
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'FantasyName',
                OrderDescending: false
            }

            if (vm.selectedEconomicGroup || vm.selectedCluster || vm.selectedStatus || vm.searchStatus > 0 || (vm.selectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.searchStatus > 0)
                params.Active = vm.searchStatus == 1;

            if (vm.selectedEconomicGroup)
                params.EconomicGroupId = vm.selectedEconomicGroup.Id;

            if (vm.selectedCluster)
                params.ClusterId = vm.selectedCluster.Id;

            if (vm.selectedStatus)
                params.StatusId = vm.selectedStatus.Id;

            if (vm.selectedStatus && vm.selectedStatus.Id == 6) {
                vm.searchStatus = null;
                params.Closed = true;
                params.Active = false;
            }

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function prepareReportParameters() {
            let params = {};

            if (vm.searchStatus > 0)
                params.Active = vm.searchStatus == 1;

            if (vm.selectedEconomicGroup)
                params.EconomicGroupId = vm.selectedEconomicGroup.Id;

            if (vm.selectedCluster)
                params.ClusterId = vm.selectedCluster.Id;

            if (vm.selectedStatus)
                params.StatusId = vm.selectedStatus.Id;

            if (vm.selectedStatus && vm.selectedStatus.Id == 6) {
                vm.searchStatus = null;
                params.Closed = true;
                params.Active = false;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function init() {
            const loggedUserData = AuthenticationService.getSelectedData();

            vm.canUserHandlePerson = AuthenticationService.getUnitDataByAccessLevelAndModuleId(loggedUserData.AccessLevelId, SYSTEM_MODULES.FRANCHISER_PEOPLE).length > 0;
            vm.selectedCluster;
            vm.selectedStatus;
            vm.selectedEconomicGroup;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;
            vm.searchStatus = 1;

            vm.searchFields = [{
                Value: 'Id',
                Description: 'Id'
            }, {
                Value: 'Document',
                Description: 'CNPJ'
            }, {
                Value: 'CorporateName',
                Description: 'Razão Social'
            }, {
                Value: 'FantasyName',
                Description: 'Nome Fantasia'
            }, {
                Value: 'ExternalCode',
                Description: 'Código Loja'
            }, {
                Value: 'UniqueCode',
                Description: 'Código Único'
            }];

            HelperService.startLoading('.custom-filters');

            $q.all([getEconomicGroups(), getClusters(), getStatus()])
                .then(() => {
                    HelperService.stopLoading('.custom-filters');
                })
        }
    }
}());